import { useSelector } from 'react-redux';
import { Text } from '@taxdown/piccolo-web';
import { locizeNS } from 'Services/i18n';
import { phoneSelector } from 'Store/modules/auth/selectors';
import useTranslation from 'Hooks/useTranslation';
import RetryButton from 'Containers/Datagathering/components/RetryButton';
import TwoColLayout from 'Components/Layouts/TwoColLayout';
import { lottiesPaths } from 'Constants/lottiesPaths';
import * as Styled from './styles';

const DataGatheringError = (): JSX.Element => {
  const { t } = useTranslation(locizeNS.DG);
  const phoneNumber = useSelector(phoneSelector);
  return (
    <TwoColLayout>
      <Styled.ContentContainer>
        <Styled.LottieContainer options={{ path: lottiesPaths.SAT_ERROR }} />
        <Styled.FlexContainer direction="column" align="center" gap="dimension_16">
          <Text type="headline" color="dark" size="S_L_S" align="center">
            {t('DG.Retry.title')}
          </Text>
          <Text type="paragraphs" size="M_S_S" color="dark" align="center">
            {t('DG.Retry.subtitle')}
          </Text>
          <Text type="paragraphs" size="M_S_S" color="success_strong" align="center">
            {phoneNumber}
          </Text>
        </Styled.FlexContainer>
        <RetryButton />
      </Styled.ContentContainer>
    </TwoColLayout>
  );
};

export default DataGatheringError;
